import clsx from 'clsx';
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import AbstractDialogTab from '../../../../../react/features/base/dialog/components/web/AbstractDialogTab';
import { translate } from '../../../../../react/features/base/i18n/functions';
import { isLocalParticipantModerator } from '../../../../../react/features/base/participants/functions';
import { withPixelLineHeight } from '../../../../../react/features/base/styles/functions.web';
import Checkbox from '../../../../../react/features/base/ui/components/web/Checkbox';
import Select from '../../../../../react/features/base/ui/components/web/Select';
import { TALK_RATE_ITEMS } from '../../../hints/constants';
const styles = (theme) => {
    return {
        container: {
            marginBottom: theme.spacing(2)
        },
        wrapper: {
            width: '100%'
        },
        separator: {
            marginTop: 20,
            marginBottom: 20,
            border: '1px solid #4C4D50',
            borderBottom: 0
        },
        title: {
            ...withPixelLineHeight(theme.typography.heading6),
            color: `${theme.palette.text01} !important`,
            marginBottom: theme.spacing(3)
        }
    };
};
class AdvancedTab extends AbstractDialogTab {
    constructor(props) {
        super(props);
        const { transcriptionAutostart, recordingAutostart, preJoinScreen } = props;
        this._onTranscriptionAutostart = this._onTranscriptionAutostart.bind(this);
        this._onRecordingAutoStart = this._onRecordingAutoStart.bind(this);
        this._onPreJoinScreen = this._onPreJoinScreen.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onSelectHints = this.onSelectHints.bind(this);
        this.state = {
            transcriptionAutostart,
            recordingAutostart,
            preJoinScreen
        };
    }
    onSelectHints(e) {
        const selectedRatio = Number(e.target.value);
        const selectedHint = TALK_RATE_ITEMS.find(item => item.ratio === selectedRatio);
        if (selectedHint) {
            const { slug, nameKey, ratio } = selectedHint;
            super._onChange({ presetHints: {
                    slug,
                    nameKey,
                    ratio
                } });
        }
    }
    renderSelectHints() {
        const { presetHints, enabled, t } = this.props;
        const options = TALK_RATE_ITEMS.map(i => {
            return {
                label: t(i.nameKey),
                value: i.ratio
            };
        });
        return (React.createElement("div", { className: 'hints-select' },
            React.createElement(Select, { id: 'hints', disabled: !enabled, label: t('hints.talkRatio'), onChange: this.onSelectHints, options: options, value: presetHints?.ratio || TALK_RATE_ITEMS[0].ratio })));
    }
    renderHintsContent() {
        const { enabled, enabledSoundHints, t } = this.props;
        return (React.createElement("div", { className: 'hints-tab', key: 'hints' },
            React.createElement("div", null,
                React.createElement(Checkbox, { checked: enabled, label: t('hints.enable'), name: 'enabled', onChange: this.onCheckboxChange })),
            React.createElement(Checkbox, { checked: enabledSoundHints, disabled: !enabled, label: t('hints.enableSound'), name: 'enabledSoundHints', onChange: this.onCheckboxChange }),
            this.renderSelectHints()));
    }
    onCheckboxChange({ target: { name, checked } }) {
        super._onChange({ [name]: checked });
    }
    _onTranscriptionAutostart() {
        this.setState({
            transcriptionAutostart: !this.state.transcriptionAutostart,
            recordingAutostart: !this.state.transcriptionAutostart
        }, () => {
            super._onChange({
                transcriptionAutostart: this.state.transcriptionAutostart,
                recordingAutostart: this.state.recordingAutostart
            });
        });
    }
    _onPreJoinScreen() {
        this.setState({
            preJoinScreen: !this.state.preJoinScreen
        }, () => {
            super._onChange({
                preJoinScreen: this.state.preJoinScreen
            });
        });
    }
    _onRecordingAutoStart() {
        this.setState({ recordingAutostart: !this.state.recordingAutostart }, () => {
            super._onChange({
                recordingAutostart: this.state.recordingAutostart
            });
        });
    }
    renderRecordingTranscription() {
        const { classes, t } = this.props;
        const { transcriptionAutostart, recordingAutostart } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.container },
                React.createElement(Checkbox, { checked: transcriptionAutostart, label: t('settings.externalMeetingsTranscription'), 
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange: this._onTranscriptionAutostart })),
            React.createElement("div", { className: classes.container },
                React.createElement(Checkbox, { checked: recordingAutostart, disabled: !transcriptionAutostart, label: t('settings.externalMeetingsRecording'), 
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange: this._onRecordingAutoStart }))));
    }
    renderPreJoin() {
        const { classes, t } = this.props;
        const { preJoinScreen } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.container },
                React.createElement(Checkbox, { checked: preJoinScreen, label: t('settings.preJoinDescription'), 
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange: this._onPreJoinScreen }))));
    }
    renderNoiseContent() {
        // @ts-ignore
        const { noiseSuppressionEnabled, t } = this.props;
        return (React.createElement("div", { className: 'noise-tab', key: 'noise' },
            React.createElement("div", null,
                React.createElement(Checkbox, { checked: noiseSuppressionEnabled, label: t('settings.noise'), 
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange: () => super._onChange({
                        noiseSuppressionEnabled: !noiseSuppressionEnabled
                    }) }))));
    }
    renderAutoPIP() {
        const { autoPipEnabled, classes, t } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: clsx('auto-pip-checkbox', classes.container) },
                React.createElement(Checkbox, { checked: autoPipEnabled, label: t('settings.autoPip'), 
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange: () => super._onChange({
                        autoPipEnabled: !autoPipEnabled
                    }) }))));
    }
    render() {
        const { isPbxUser, isXbees, classes, isHintsAllowed } = this.props;
        return (React.createElement("div", { className: classes.wrapper, key: 'advanced-tab' },
            isXbees && React.createElement(React.Fragment, null,
                this.renderPreJoin(),
                React.createElement("hr", { className: classes.separator })),
            isXbees && isPbxUser && React.createElement(React.Fragment, null,
                this.renderRecordingTranscription(),
                React.createElement("hr", { className: classes.separator })),
            isHintsAllowed && React.createElement(React.Fragment, null,
                this.renderHintsContent(),
                React.createElement("hr", { className: classes.separator })),
            this.renderNoiseContent(),
            isXbees && React.createElement(React.Fragment, null,
                React.createElement("hr", { className: classes.separator }),
                this.renderAutoPIP())));
    }
}
export function _mapStateToProps(state) {
    // @ts-ignore
    const { isXbees } = state['features/base/config'];
    const isHintsAllowed = isLocalParticipantModerator(state);
    return {
        isXbees,
        isHintsAllowed
    };
}
export default withStyles(translate(connect(_mapStateToProps)(AdvancedTab)), styles);
